
import axios from 'axios'
import { getHost } from './tool.js'

// 创建axios实例
const getAxiosUpload = (baseURL, config) => {  
  const axiosUpload = axios.create({
    // 判断正式网与测试网 请求ip域名不一样
    baseURL: baseURL,
    timeout: 30000 // 请求超时时间
    // withCredentials: true
  })
  // request拦截器
  axiosUpload.interceptors.request.use(config => {
    return config
  }, error => {
    // Do something with request error
    Promise.reject(error)
  })
  // response 拦截器
  axiosUpload.interceptors.response.use(response => {
    return response.data
  }, error => {
    return Promise.reject(error)
  })
  return new Promise((resolve, reject) => {
    axiosUpload(config).then((res) => {
      return resolve(res)
    }).catch((error) => {
      return reject(error)
    })
  })
}
const axiosUploadExt = (config) => {
  return new Promise((resolve, reject) => {
    getHost().then(host => {
      return getAxiosUpload(host, config).then(res => {
        return resolve(res)
      }).catch((error) => {
        return reject(error)
      })
    })
  })
}
export {
  axiosUploadExt
}
